import React from 'react'
import { Link } from 'gatsby'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import { useHeaderImagesSmall } from 'src/hooks/useHeaderImagesSmall'
import { useHeaderImagesMedium } from 'src/hooks/useHeaderImagesMedium'
import { useHeaderImagesLarge } from 'src/hooks/useHeaderImagesLarge'
import { roles } from 'training-lane-booking-shared/utilities/constants'
import logoClasses from './Logo.module.scss'
import { useSelector } from 'react-redux'

const Logo = ({
    landingPage = false,
    isStaffOrAdmin = false,
    bookingPage = '',
    isXSmall = false,
    isMedium = false,
    showHeader = false
}) => {
    const roleId = useSelector(state => state.firebase.profile?.token?.claims?.roleId)
    const imagesSmall = useHeaderImagesSmall()
    const imagesMedium = useHeaderImagesMedium()
    const imagesLarge = useHeaderImagesLarge()

    const getImageByFileName = (image, fileName) => image.find(
        img => {
            const { name, ext } = img.node.parent
            const imgFileName = name + ext

            return imgFileName.includes(fileName)
        }
    ).node.gatsbyImageData

    const largeLogo = getImageByFileName(imagesLarge, 'TrainingLane_logo_transparent.png')

    const mediumLogo = getImageByFileName(imagesMedium, 'TrainingLane_logo_transparent.png')

    const smallLogo = getImageByFileName(imagesSmall, 'TrainingLane_logo_transparent.png')

    // noinspection SpellCheckingInspection
    const wideLogo = getImageByFileName(imagesLarge, 'TrainingLane_logo_withtextright_whitebg.jpg')

    const colNum = size => {
        if (isStaffOrAdmin) {
            return 4
        }
        if (landingPage) {
            return size === 'large' ? 3 : 2
        }
        if (isMedium && roles.vip.id === roleId) {
            return 4
        }
        return size === 'large' ? 4 : isXSmall ? 2 : bookingPage.length ? 1 : 4
    }

    return ['small', 'large'].map((size, i) => (
        <Link
            key={i}
            to="/"
            className={classNames(
                logoClasses.logo,
                logoClasses[size],
                `col-${colNum(size)}`,
                `large-${size === 'large' ? 'hidden' : 'visible'}`,
                'align-left',
                {
                    [logoClasses.high]: landingPage,
                    [logoClasses.tiny]: showHeader && isXSmall
                }
            )}>
            <GatsbyImage
                image={
                    landingPage || (!showHeader && isXSmall)
                        ? largeLogo
                        : size === 'large'
                            ? wideLogo
                            : isMedium
                                ? mediumLogo
                                : smallLogo
                }
                loading="lazy"
                alt={`Logo ${size}`}
            />
        </Link>
    ))
}

export default Logo
